module.exports = __webpack_public_path__ + "img/cards1_front141.6f6cecc9.png";